import {AppRoutes} from '@shared/core/constants';

export const FORCE_COLLAPSED_PAGE_PATHS = {
  [AppRoutes.Floors]: ['/', '/:id'],
  [AppRoutes.Geotrack]: ['/', '/:tab'],
};
